function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.91616 5.00852L9.80996 1.1146C10.0634 0.861315 10.0634 0.451791 9.80996 0.198507C9.55668 -0.0547759 9.14715 -0.0547759 8.89387 0.198507L4.99995 4.09243L1.10614 0.198507C0.852741 -0.0547759 0.443335 -0.0547759 0.190052 0.198507C-0.0633505 0.451791 -0.0633505 0.861315 0.190052 1.1146L4.08386 5.00852L0.190052 8.90244C-0.0633505 9.15572 -0.0633505 9.56525 0.190052 9.81853C0.316278 9.94487 0.482247 10.0083 0.648097 10.0083C0.813948 10.0083 0.979798 9.94487 1.10614 9.81853L4.99995 5.92461L8.89387 9.81853C9.02022 9.94487 9.18607 10.0083 9.35192 10.0083C9.51777 10.0083 9.68362 9.94487 9.80996 9.81853C10.0634 9.56525 10.0634 9.15572 9.80996 8.90244L5.91616 5.00852Z",
  fill: "#E7E7E7"
});
function SvgCrossIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.9c03cd82.svg";
export { ForwardRef as ReactComponent };